import React from "react";
import { Link } from "react-router-dom";
import bannerImage from "../img/banner-bg.jpg"; // replace with your image path
import { FaBookOpen } from "react-icons/fa";

function Banner() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-white text-center Banner-Section"
      style={{
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed", // this makes it stick (parallax effect)
        backgroundPosition: "center",
        minHeight: "80vh", // big banner
        position: "relative",
      }}
    >
      {/* Optional overlay for better text visibility */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)", // semi-transparent dark overlay
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div style={{ position: "relative", zIndex: 2 }}>
        <h1 className="display-4 fw-bold">Professional Home Cleaning</h1>
        <p className="lead my-3">
          Reliable & affordable cleaning services at your doorstep
        </p>
        <Link  to="/about" className="service-btn d-inline-flex align-items-center gap-2">Learn More
                               <FaBookOpen />
                       </Link>
      </div>
    </div>
  );
}

export default Banner;
